// Shared formatting helpers for the admin reporting surfaces
// (AdminReportsPage.js, AdminFacultyDrilldownPage.js). Every one of these
// must render legibly on missing/zero data (docs/reporting-metrics-spec.md
// §12.5) — never a blank cell, never a literal "NaN", never a bare 0% for a
// metric that had nothing to measure.

export const DASH = '—';

export function fmtPct(value, digits = 1) {
  return value === null || value === undefined ? DASH : `${value.toFixed(digits)}%`;
}

export function fmtAge(days) {
  if (days === null || days === undefined) return DASH;
  if (days < 1) return `${Math.round(days * 24)}h`;
  return `${days.toFixed(1)}d`;
}

export function fmtMinutes(minutes) {
  if (minutes === null || minutes === undefined) return DASH;
  if (minutes < 60) return `${Math.round(minutes)}m`;
  if (minutes < 60 * 24) return `${(minutes / 60).toFixed(1)}h`;
  return `${(minutes / (60 * 24)).toFixed(1)}d`;
}

export function pctTone(ratePct, { goodAt = 90, okAt = 70 } = {}) {
  if (ratePct === null || ratePct === undefined) return 'bg-slate-100 text-slate-500 dark:bg-slate-700 dark:text-slate-400';
  if (ratePct >= goodAt) return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300';
  if (ratePct >= okAt) return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300';
  return 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300';
}
